import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  useEffect(() => {
    // AOS Animation initialization
    const elements = document.querySelectorAll('[data-aos]');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('aos-animate');
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    elements.forEach(el => observer.observe(el));

    // Back to Top Button functionality
    const backToTop = document.getElementById("backToTop");
    if (backToTop) {
      window.onscroll = function () {
        if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
          backToTop.style.display = "block";
        } else {
          backToTop.style.display = "none";
        }
      };

      backToTop.addEventListener("click", () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  }, []);

  return (
    <>
      {/* Page Header */}
      <section className="page-header">
        <div className="container">
          <h1>About WE CARE ASSURANCE</h1>
          <p>Your trusted partner in insurance since 2003</p>
        </div>
      </section>

      {/* About Story */}
      <section className="about-story">
        <div className="container">
          <div className="story-grid">
            <div className="story-content" data-aos="fade-right">
              <h2>Our Story</h2>
              <p>
                Founded in 2003, WE CARE ASSURANCE began with a simple mission: to
                provide reliable, affordable insurance coverage with a personal
                touch. What started as a small family business has grown into one
                of India's most trusted insurance providers.
              </p>
              <p>
                Over the past 22 years, we have protected over 6,000 families and
                businesses, settling claims worth millions with a 98% settlement
                ratio. Our commitment to transparency, customer service, and
                innovative solutions has made us a leader in the insurance
                industry.
              </p>
              <p>
                Today, we continue to evolve and adapt to meet the changing needs
                of our customers, leveraging technology while maintaining the
                personal relationships that have always been at the heart of our
                business.
              </p>
            </div>
            <div className="story-image" data-aos="fade-left">
              <img src="assets/ourstory.jpg" alt="Our Story" />
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="vision-mission">
        <div className="container">
          <div className="vm-grid">
            <div className="vm-card" data-aos="fade-up">
              <div className="vm-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M1 12S5 4 12 4S23 12 23 12S19 20 12 20S1 12 1 12Z"
                    stroke="#0057A4"
                    strokeWidth="2"
                  />
                  <circle
                    cx="12"
                    cy="12"
                    r="3"
                    stroke="#0057A4"
                    strokeWidth="2"
                  />
                </svg>
              </div>
              <h3>Our Vision</h3>
              <p>
                To be India's most trusted insurance partner, providing
                comprehensive protection and peace of mind to every family and
                business we serve.
              </p>
            </div>
            <div className="vm-card" data-aos="fade-up" data-aos-delay="100">
              <div className="vm-icon">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2L3 7L12 12L21 7L12 2Z"
                    stroke="#E74C3C"
                    strokeWidth="2"
                  />
                  <path d="M3 17L12 22L21 17" stroke="#E74C3C" strokeWidth="2" />
                  <path d="M3 12L12 17L21 12" stroke="#E74C3C" strokeWidth="2" />
                </svg>
              </div>
              <h3>Our Mission</h3>
              <p>
                To deliver exceptional insurance solutions through innovation,
                integrity, and unwavering commitment to customer satisfaction,
                ensuring financial security for all.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="core-values">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Core Values</h2>
            <p className="section-subtitle">
              The principles that guide everything we do
            </p>
          </div>
          <div className="values-grid">
            <div className="value-card" data-aos="fade-up">
              <div className="value-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2L3 7L12 12L21 7L12 2Z"
                    stroke="#0057A4"
                    strokeWidth="2"
                  />
                  <path d="M3 17L12 22L21 17" stroke="#0057A4" strokeWidth="2" />
                  <path d="M3 12L12 17L21 12" stroke="#0057A4" strokeWidth="2" />
                </svg>
              </div>
              <h3>Trust</h3>
              <p>
                Building lasting relationships through honesty, transparency, and
                reliable service that our customers can depend on.
              </p>
            </div>
            <div className="value-card" data-aos="fade-up" data-aos-delay="100">
              <div className="value-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 22S2 16 2 10V5L12 2L22 5V10C22 16 12 22 12 22Z"
                    stroke="#0057A4"
                    strokeWidth="2"
                  />
                </svg>
              </div>
              <h3>Assurance</h3>
              <p>
                Providing comprehensive coverage and guaranteed support when our
                customers need it most, with quick claim settlements.
              </p>
            </div>
            <div className="value-card" data-aos="fade-up" data-aos-delay="200">
              <div className="value-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20.84 4.61A5.5 5.5 0 0 0 16.5 2C13.76 2 12 3.64 12 3.64S10.24 2 7.5 2A5.5 5.5 0 0 0 3.16 4.61C2.42 7.55 3.14 12.22 12 21.5C20.86 12.22 21.58 7.55 20.84 4.61Z"
                    stroke="#E74C3C"
                    strokeWidth="2"
                  />
                </svg>
              </div>
              <h3>Care</h3>
              <p>
                Treating every customer like family, with personalized attention
                and genuine concern for their well-being and security.
              </p>
            </div>
            <div className="value-card" data-aos="fade-up" data-aos-delay="300">
              <div className="value-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="#0057A4"
                    strokeWidth="2"
                  />
                  <path d="M16 12L12 8L8 12" stroke="#0057A4" strokeWidth="2" />
                  <path d="M12 16V8" stroke="#0057A4" strokeWidth="2" />
                </svg>
              </div>
              <h3>Excellence</h3>
              <p>
                Continuously improving our services and products to exceed
                expectations and set new standards in the insurance industry.
              </p>
            </div>
            <div className="value-card" data-aos="fade-up" data-aos-delay="400">
              <div className="value-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M12 2L2 7L12 12L22 7L12 2Z"
                    stroke="#E74C3C"
                    strokeWidth="2"
                  />
                  <path d="M2 17L12 22L22 17" stroke="#E74C3C" strokeWidth="2" />
                  <path d="M2 12L12 17L22 12" stroke="#E74C3C" strokeWidth="2" />
                </svg>
              </div>
              <h3>Innovation</h3>
              <p>
                Embracing technology and new ideas to create better, more
                efficient solutions for our customers' evolving needs.
              </p>
            </div>
            <div className="value-card" data-aos="fade-up" data-aos-delay="500">
              <div className="value-icon">
                <svg width="50" height="50" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M17 21V19C17 16.79 15.21 15 13 15H5C2.79 15 1 16.79 1 19V21"
                    stroke="#0057A4"
                    strokeWidth="2"
                  />
                  <circle cx="9" cy="7" r="4" stroke="#0057A4" strokeWidth="2" />
                  <path
                    d="M23 21V19C23 16.79 21.21 15 19 15C18.4 15 17.85 15.1 17.35 15.3"
                    stroke="#0057A4"
                    strokeWidth="2"
                  />
                  <path
                    d="M16 3.13C16.84 3.35 17.45 4.13 17.45 5C17.45 5.87 16.84 6.65 16 6.87"
                    stroke="#0057A4"
                    strokeWidth="2"
                  />
                </svg>
              </div>
              <h3>Integrity</h3>
              <p>
                Operating with the highest ethical standards, ensuring fairness
                and honesty in all our business practices and decisions.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Leadership */}
      <section className="leadership">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Leadership Team</h2>
            <p className="section-subtitle">
              Meet the experienced professionals leading WE CARE ASSURANCE
            </p>
          </div>
          <div className="team-grid">
            <div className="team-member" data-aos="fade-up">
              <img src="assets/Nishith Pandya.png" alt="CEO" />
              <div className="member-info">
                <h3>Nishith Pandya</h3>
                <p className="member-role">Corporate Line</p>
                <p className="member-bio">
                  With over 20 years in the insurance industry, Nishith leads our
                  vision of making insurance accessible and reliable for all.
                </p>
              </div>
            </div>
            <div className="team-member" data-aos="fade-up" data-aos-delay="100">
              <img src="assets/nikhil_thakkar.png" alt="CTO" />
              <div className="member-info">
                <h3>Nikhil Thakkar</h3>
                <p className="member-role">Mentor</p>
                <p className="member-bio">
                  Nikhil Sir is our guiding mentor at WE CARE ASSURANCE, providing
                  strategic direction and inspiring us to deliver excellence in
                  every service.
                </p>
              </div>
            </div>
            <div className="team-member" data-aos="fade-up" data-aos-delay="200">
              <img src="assets/Prakash Machhi.png" alt="Claims Head" />
              <div className="member-info">
                <h3>Prakash Machhi</h3>
                <p className="member-role">Personal Line</p>
                <p className="member-bio">
                  Prakash Machhi is a trusted insurance advisor specializing in
                  health and life insurance, dedicated to helping families choose
                  the right coverage with clear and personalized guidance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Corporate Insurance Team */}
      <section className="corporate-team">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Corporate Insurance Team</h2>
            <p className="section-subtitle">
              Our experts providing tailored insurance solutions for businesses
            </p>
          </div>
          <div className="team-grid">
            <div className="team-member" data-aos="fade-up">
              <img src="assets/urvashi.jpg" alt="Sales Support" />
              <div className="member-info">
                <h3>Urvashi Makwana</h3>
                <p className="member-role">Sales Support</p>
                <p className="member-bio">
                  Over 5 years of experience assisting corporate clients with
                  customized insurance plans.
                </p>
              </div>
            </div>
            <div className="team-member" data-aos="fade-up" data-aos-delay="100">
              <img src="assets/pankaj.jpg" alt="Sales Support" />
              <div className="member-info">
                <h3>Pankaj Chavda</h3>
                <p className="member-role">Sales Support</p>
                <p className="member-bio">
                  5+ years in corporate insurance, ensuring smooth support and
                  customer satisfaction.
                </p>
              </div>
            </div>
            <div className="team-member" data-aos="fade-up" data-aos-delay="200">
              <img src="assets/kishan.png" alt="Sales Executive" />
              <div className="member-info">
                <h3>Kishan Jadhav</h3>
                <p className="member-role">Sales Executive</p>
                <p className="member-bio">
                  Focused on building strong client relationships and delivering
                  value-driven insurance solutions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Personal Line Team */}
      <section className="personal-team">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Personal Line Team</h2>
            <p className="section-subtitle">
              Dedicated professionals supporting individual insurance needs
            </p>
          </div>
          <div className="team-grid">
            <div className="team-member" data-aos="fade-up">
              <img src="assets/jaymin.jpg" alt="Sales Support" />
              <div className="member-info">
                <h3>Jaimin Parmar</h3>
                <p className="member-role">Sales Support</p>
                <p className="member-bio">
                  Helps clients select the right personal insurance policies for
                  their needs.
                </p>
              </div>
            </div>
            <div className="team-member" data-aos="fade-up" data-aos-delay="100">
              <img src="assets/nidhi.jpg" alt="Claims Team" />
              <div className="member-info">
                <h3>Nidhi Mistry</h3>
                <p className="member-role">Claims Team</p>
                <p className="member-bio">
                  Expert in handling and processing individual claims with empathy
                  and efficiency.
                </p>
              </div>
            </div>
            <div className="team-member" data-aos="fade-up" data-aos-delay="200">
              <img src="assets/komal dhamecha.jpg" alt="Back Office Team" />
              <div className="member-info">
                <h3>Komal Dhamecha</h3>
                <p className="member-role">Back Office Team</p>
                <p className="member-bio">
                  Ensures smooth operations and back-end support for customer
                  policies.
                </p>
              </div>
            </div>
            <div className="team-member" data-aos="fade-up" data-aos-delay="300">
              <img src="assets/rahul.jpg" alt="Office Support" />
              <div className="member-info">
                <h3>Rahul Chavda</h3>
                <p className="member-role">Office Support</p>
                <p className="member-bio">
                  Provides essential office assistance to ensure seamless customer
                  service delivery.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Awards & Recognition */}
      <section className="awards">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Awards & Recognition</h2>
            <p className="section-subtitle">
              Acknowledged for excellence in service and customer satisfaction
            </p>
          </div>

          <div className="awards-grid">
            <div className="award-item" data-aos="fade-up">
              <img
                src="assets/award4.jpg"
                alt="Award 1 - MDRT 2024"
                className="award-img"
              />
              <h3>MDRT 2024 Achievement</h3>
              <p>
                Recognized for outstanding performance and achieving MDRT 2024
              </p>
            </div>

            <div className="award-item" data-aos="fade-up" data-aos-delay="100">
              <img
                src="assets/award3.jpg"
                alt="Award 2 - Pillar of Success"
                className="award-img"
              />
              <h3>Pillar of Success</h3>
              <p>Honored for being a strong pillar of organizational success</p>
            </div>

            <div className="award-item" data-aos="fade-up" data-aos-delay="200">
              <img
                src="assets/award2.jpg"
                alt="Award 3 - MDRT On Track"
                className="award-img"
              />
              <h3>MDRT On Track</h3>
              <p>
                Awarded for consistent performance and staying on track with MDRT
                goals
              </p>
            </div>

            <div className="award-item" data-aos="fade-up" data-aos-delay="300">
              <img
                src="assets/award1.jpg"
                alt="Award 4 - Dubai Cruise Recognition"
                className="award-img"
              />
              <h3>Dubai Cruise Recognition</h3>
              <p>
                Special recognition for achieving excellence and qualifying for
                Dubai Cruise 2025
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content" data-aos="fade-up">
            <h2>Experience the WE CARE Difference</h2>
            <p>
              Join our family of satisfied customers and discover why we're
              India's trusted insurance partner
            </p>
            <div className="cta-buttons">
              <Link to="/plans" className="btn-primary">Explore Plans</Link>
              <Link to="/contact" className="btn-secondary">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Back to Top Button */}
      <button id="backToTop" title="Go to top">↑</button>
    </>
  );
};

export default About;
